angular.module('login', [
  'login.index',
  'login.forgot',
  'login.reset',
  'login.social',
  'login.change_pass'
]);



// WEBPACK FOOTER //
// ./client/src/app/login/index.js